import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import ChecklistItemRow from './checklist_item_row';
import { snakeCase } from 'helpers/formatters/string_formats';
import { editChecklistItem, reorderChecklistItemsLocally, reorderChecklistItemsRemotely } from '../actions/index';

export class ChecklistSection extends Component {
  static propTypes = {
    checklistItems: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      listingType: PropTypes.string,
      projectStatus: PropTypes.string,
      taskTitle: PropTypes.string
    })).isRequired,
    editChecklistItem: PropTypes.func.isRequired,
    listingType: PropTypes.string.isRequired,
    projectStatus: PropTypes.string.isRequired,
    projectTypeLabel: PropTypes.string.isRequired,
    relation: PropTypes.string,
    reorderChecklistItemsLocally: PropTypes.func.isRequired,
    reorderChecklistItemsRemotely: PropTypes.func.isRequired,
    showChecklistItemModal: PropTypes.func.isRequired,
    statusLabel: PropTypes.string.isRequired
  };

  filterChecklistItems() {
    return this.props.checklistItems.filter((item) => {
      return item.listingType === this.props.listingType && item.projectStatus === this.props.projectStatus;
    });
  }

  editItem = (item) => {
    this.props.editChecklistItem(item);
  };

  showChecklistItemModal = (e) => {
    e.preventDefault();
    this.props.showChecklistItemModal(this.props.projectStatus, this.props.listingType);
  };

  listItem = (item, index) => {
    const listName = `checklist-items-for-${this.props.projectTypeLabel}-${this.props.statusLabel}`;
    return (
      <ChecklistItemRow
        checklistItem={item}
        clickAction={() => this.editItem(item)}
        id={item.id}
        index={index}
        key={item.id}
        listName={listName}
        targetGroup={listName}
        onReorder={this.reorderItems}
      />
    );
  };

  debouncedReorderChecklistItemsRemotely = debounce(this.props.reorderChecklistItemsRemotely, 1000);

  reorderItems = (dragIndex, hoverIndex) => {
    const checklistItems = this.filterChecklistItems();
    const dragItem = checklistItems[dragIndex];

    checklistItems.splice(dragIndex, 1);
    checklistItems.splice(hoverIndex, 0, dragItem);
    this.props.reorderChecklistItemsLocally(checklistItems);
    this.debouncedReorderChecklistItemsRemotely(checklistItems);
  };

  renderItems() {
    const checklistItems = this.filterChecklistItems();

    if (checklistItems.length > 0) {
      const listItems = checklistItems.map(this.listItem);

      return (
        <ul className="list-group">
          {listItems}
        </ul>
      );
    } else {
      return <hr />;
    }
  }

  render() {
    return (
      <div>
        <div className="row-eq-height mb-3">
          <div className="grow">
            <h4>
              <strong>{this.props.statusLabel}</strong>
            </h4>
            <div>
              Tasks to be completed in the {this.props.statusLabel} status for {this.props.projectTypeLabel}.
              {this.props.relation &&
                <span> These Tasks are related to the {this.props.relation}.</span>
              }
            </div>
          </div>
          <div className="align-bottom">
            <a href="#" onClick={this.showChecklistItemModal}>
              <FontAwesomeIcon className="mr-1" icon={faPlus} />
              Task
            </a>
          </div>
        </div>
        {this.renderItems()}
      </div>
    );
  }
}

function mapStateToProps({ checklistItems }) {
  return { checklistItems };
}

export default connect(
  mapStateToProps,
  { editChecklistItem, reorderChecklistItemsLocally, reorderChecklistItemsRemotely }
)(ChecklistSection);
